// @ts-nocheck

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AnimateHeight from 'react-animate-height'

import { Glyph } from '../../../LEGACY/Glyph'
import { colors } from '@lmc/common/constants'
import { Icon } from '../Icon'

export default class DropdownTitle extends Component {
  state = {
    isOpen: false,
  }

  componentDidMount() {
    const { isOpen } = this.props

    this.setState({ isOpen })
  }

  componentDidUpdate(prevProps) {
    const { isOpen } = this.props

    if (prevProps.isOpen !== isOpen) {
      this.setState({ isOpen })
    }
  }

  toggleOpen = () => {
    const { toggleOpen } = this.props

    toggleOpen
      ? toggleOpen()
      : this.setState((prevState) => ({
          isOpen: !prevState.isOpen,
        }))
  }

  renderCompletionGlyph = () => {
    const { isComplete, isPending } = this.props
    if (!isComplete && !isPending) return null

    if (isComplete) {
      return (
        <Icon
          name="tick-in-circle"
          size={24}
          fill={colors.successgreen}
          style={styles.completionGlyph}
        />
      )
    }

    return (
      <Icon
        name="clock"
        size={24}
        fill={colors.yellow}
        style={styles.completionGlyph}
      />
    )
  }

  render() {
    const { children, title } = this.props

    const { isOpen } = this.state

    return (
      <div style={styles.wrapper}>
        <div onClick={this.toggleOpen} style={styles.titleBar}>
          <span style={styles.title}>{title}</span>
          <div style={styles.glyphsContainer}>
            {this.renderCompletionGlyph()}
            <Glyph
              name={isOpen ? 'chevron-up' : 'chevron-down'}
              size="small"
              style={styles.glyph}
            />
          </div>
        </div>
        <AnimateHeight
          animateOpacity
          height={isOpen ? 'auto' : 0}
          duration={300}
        >
          {isOpen ? children : null}
        </AnimateHeight>
      </div>
    )
  }
}

DropdownTitle.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
}

const styles = {
  completionGlyph: {
    marginRight: 20,
    alignSelf: 'center',
  },
  glyph: {
    alignSelf: 'flex-end',
    fontSize: 24,
  },
  glyphsContainer: {
    display: 'flex',
  },
  title: {
    fontSize: 20,
  },
  titleBar: {
    borderBottom: `2px solid ${colors.grey}`,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 15px 3px 2px',
  },
  wrapper: {
    marginTop: 5,
  },
}
